import { Button, Dropdown } from 'antd';
import classNames from 'classnames';
import { UpOutlined } from '@ant-design/icons';
import { IconFont } from '../../../component/icon-font';
import { getAntdDropdownMenu, getAntdItem } from './video-footer-utils';
import { Box, Button as ChakraButton } from '@chakra-ui/react';
import { isMobile } from '../../../utils/DeviceType';
import useLanguageSelector from '../../../hooks/useLanguageSelector';
const { Button: DropdownButton } = Dropdown;
interface LeaveButtonProps {
  onLeaveClick: () => void;
  onEndClick: () => void;
  isHost: boolean;
}

const LeaveButton = (props: LeaveButtonProps) => {
  const LANG = useLanguageSelector();
  const { onLeaveClick, onEndClick, isHost } = props;

  return (
    <Box className={'leave-footer'}>
      {/* {isHost ? (
        <DropdownButton
          className="vc-dropdown-button"
          size="large"
          menu={getAntdDropdownMenu([getAntdItem('End session', 'end')], onEndClick)}
          trigger={['click']}
          type="ghost"
          onClick={onLeaveClick}
          icon={<UpOutlined />}
          placement="topRight"
        >
          <IconFont type="icon-leave" />
          {isMobile() || LANG.KT_0100_16}
        </DropdownButton>
      ) : ( */}
      <Button
        className={classNames('vc-button')}
        icon={<IconFont type="icon-leave" />}
        // eslint-disable-next-line react/jsx-boolean-value
        ghost={true}
        shape="default"
        size="large"
        onClick={onLeaveClick}
        title="Leave session"
      >
        {isMobile() || LANG.KT_0100_16}
      </Button>
      {/* )} */}
    </Box>
  );
};

export default LeaveButton;
